// Heeral — comportamento da PDP do robe (shadow root de <zl-pdp>): galeria com miniaturas, cores,
// Bundle & Save (1/2/3 un. com cor por unidade), add to cart com a gaveta do Horizon, barra fixa de compra.
const money = (c) => '$' + (c / 100).toFixed(2);
async function addToCart(host, items) {
  let Ev = null;
  try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) {}
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const deferred = Ev ? Ev.createPromise() : null;
  if (Ev) host.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })), promise: deferred.promise }));
  try {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: ids.join(','), sections_url: location.pathname }) });
    const j = await r.json(); const cart = await (await fetch('/cart.js')).json();
    if (deferred) deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: host.id, itemCount: items.reduce((a, i) => a + i.quantity, 0), productId: host.dataset.pid, sections: j.sections, didError: !!j.status } });
    if (j.status) { alert(j.description || j.message); return false; }
    if (!ids.length) { location.href = '/cart'; return true; }
    setTimeout(() => { const d = document.querySelector('cart-drawer-component'); const td = d && d.closest('theme-drawer'); if (td && td.open && !td.isOpen) td.open(); }, 400);
    return true;
  } catch (e) { if (deferred) deferred.reject(e); return false; }
}
class ZlPdp extends HTMLElement {
  connectedCallback() {
    if (this._i) return; this._i = 1;
    if (!this.shadowRoot) { const t = this.querySelector('template[shadowrootmode]'); if (t) { this.attachShadow({ mode: 'open' }).appendChild(t.content); t.remove(); } }
    const R = (this.R = this.shadowRoot);
    this.V = JSON.parse(this.querySelector('[data-zlv]').textContent).v;
    this.gallery(); this.colors(); this.bundle(); this.atc(); this.sticky();
  }
  vByColor(c) { return this.V.find((x) => x.o === c) || this.V[0]; }
  // ---------- galeria ----------
  gallery() {
    const R = this.R, main = R.querySelector('.pp-product-gallery-main'), thumbs = R.querySelector('.pp-product-gallery-thumbnails');
    if (!main) return;
    const mw = main.querySelector('.swiper-wrapper'), ms = [...mw.children], tw = thumbs && thumbs.querySelector('.swiper-wrapper'), ts = tw ? [...tw.children] : [];
    const bullets = [...R.querySelectorAll('.swiper-gallery-pagination .swiper-pagination-bullet')];
    const mob = () => innerWidth < 768;
    let i = 0;
    const layout = () => {
      const gap = +(mob() ? main.dataset.gapMobile : main.dataset.gap) || 0, w = main.clientWidth;
      ms.forEach((s) => { s.style.width = w + 'px'; s.style.marginRight = gap + 'px'; });
      mw.style.transform = `translate3d(${-i * (w + gap)}px,0,0)`;
    };
    this._layout = layout;
    const go = (k) => {
      i = Math.max(0, Math.min(ms.length - 1, k));
      ms.forEach((s, j) => { s.classList.toggle('swiper-slide-active', j === i); s.classList.toggle('swiper-slide-next', j === i + 1); s.classList.toggle('swiper-slide-prev', j === i - 1); });
      ts.forEach((s, j) => s.classList.toggle('swiper-slide-thumb-active', j === i));
      bullets.forEach((b, j) => b.classList.toggle('swiper-pagination-bullet-active', j === i));
      layoutThumbs(); layout();
    };
    const layoutThumbs = () => {
      if (!tw) return;
      const n = +(mob() ? thumbs.dataset.slidesPerViewMobile : thumbs.dataset.slidesPerView) || 6, gap = +(mob() ? thumbs.dataset.gapMobile : thumbs.dataset.gap) || 0;
      const cw = thumbs.clientWidth - parseFloat(getComputedStyle(thumbs).paddingLeft) - parseFloat(getComputedStyle(thumbs).paddingRight);
      const tw1 = (cw - gap * (n - 1)) / n;
      ts.forEach((s) => { s.style.width = tw1 + 'px'; s.style.marginRight = gap + 'px'; });
      const max = Math.max(0, ts.length - n); const first = Math.max(0, Math.min(max, i - Math.floor(n / 2) + 1));
      tw.style.transform = `translate3d(${-first * (tw1 + gap)}px,0,0)`;
      ts.forEach((s, j) => { const vis = j >= first && j < first + n; s.classList.toggle('swiper-slide-visible', vis); s.classList.toggle('swiper-slide-fully-visible', vis); });
    };
    ts.forEach((s, j) => s.addEventListener('click', () => go(j)));
    bullets.forEach((b, j) => b.addEventListener('click', () => go(j)));
    R.querySelector('.swiper-gallery-button-prev')?.addEventListener('click', () => go(i - 1));
    R.querySelector('.swiper-gallery-button-next')?.addEventListener('click', () => go(i + 1));
    // arrastar / swipe
    let x0 = null, dx = 0;
    main.addEventListener('pointerdown', (e) => { x0 = e.clientX; dx = 0; mw.style.transition = 'none'; });
    addEventListener('pointermove', (e) => { if (x0 === null) return; dx = e.clientX - x0; const gap = +(mob() ? main.dataset.gapMobile : main.dataset.gap) || 0; mw.style.transform = `translate3d(${-i * (main.clientWidth + gap) + dx}px,0,0)`; });
    addEventListener('pointerup', () => { if (x0 === null) return; mw.style.transition = ''; const k = Math.abs(dx) > 40 ? i + (dx < 0 ? 1 : -1) : i; x0 = null; go(k); });
    main.addEventListener('dragstart', (e) => e.preventDefault());
    this.go = go; new ResizeObserver(() => { layout(); layoutThumbs(); }).observe(main); go(0);
  }
  // ---------- cores ----------
  colors() {
    const R = this.R;
    R.querySelectorAll('input[data-zopt]').forEach((inp) => inp.addEventListener('change', () => {
      const v = this.vByColor(inp.value); this.cur = v;
      R.querySelector('[data-zvid]').value = v.id;
      R.querySelectorAll('select[data-zsel]').forEach((s) => { s.value = v.o; s.dataset.value = v.o; });
      if (this.go && v.m) this.go(v.m - 1);
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
    }));
    const c = R.querySelector('input[data-zopt]:checked'); this.cur = this.vByColor(c ? c.value : this.V[0].o);
  }
  // ---------- Bundle & Save ----------
  bundle() {
    const R = this.R; const bars = [...R.querySelectorAll('.kaching-bundles__bar')]; if (!bars.length) return;
    this.bars = bars;
    const sel = (b) => { bars.forEach((x) => { const on = x === b; x.classList.toggle('kaching-bundles__bar--selected', on); const i = x.querySelector('input[type=radio]'); if (i) i.checked = on; }); this.qbar = b; };
    bars.forEach((b) => { b.querySelector('.kaching-bundles__bar-main')?.addEventListener('click', (e) => { e.preventDefault(); sel(b); }); b.querySelector('label')?.addEventListener('click', (e) => { if (e.target.closest('select')) return; e.preventDefault(); sel(b); }); });
    R.querySelectorAll('select[data-zsel]').forEach((s) => s.addEventListener('change', () => { s.dataset.value = s.value; }));
    sel(bars.find((b) => b.classList.contains('kaching-bundles__bar--selected')) || bars[0]);
  }
  items() {
    const b = this.qbar, q = b ? +b.dataset.zq : 1; const sels = b ? [...b.querySelectorAll('select[data-zsel]')] : [];
    const cols = sels.length ? sels.map((s) => s.value) : Array(q).fill(this.cur.o);
    const out = []; cols.forEach((c) => { const id = this.vByColor(c).id; const it = out.find((x) => x.id === id); if (it) it.quantity++; else out.push({ id, quantity: 1 }); });
    return out;
  }
  atc() {
    const f = this.R.querySelector('[data-zform]'); if (!f) return;
    f.addEventListener('submit', async (e) => { e.preventDefault(); const b = f.querySelector('button[type=submit]'); if (b) b.disabled = true; await addToCart(this, this.items()); if (b) b.disabled = false; });
  }
  sticky() {
    const R = this.R, st = R.querySelector('pagepilot-sticky-add-to-cart'), f = R.querySelector('[data-zform]'); if (!st || !f) return;
    const btn = st.querySelector('[data-zsticky]');
    btn?.addEventListener('click', async (e) => { e.preventDefault(); await addToCart(this, this.items()); });
    const io = new IntersectionObserver(([en]) => { const show = !en.isIntersecting && en.boundingClientRect.top < 0; st.style.opacity = show ? '1' : '0'; st.style.pointerEvents = show ? 'auto' : 'none'; });
    io.observe(f);
  }
}
if (!customElements.get('zl-pdp')) customElements.define('zl-pdp', ZlPdp);
